import type React from "react"
import { memo } from "react"
import { Link } from "react-router-dom"
import { HEADER_CONSTANTS } from "../../../constants/header"

const Logo: React.FC = memo(() => (
  <div className="logo-container">
    <Link to={HEADER_CONSTANTS.ROUTES.HOME} className="logo">
      <div className="logo-icon">
        <span>{HEADER_CONSTANTS.LOGO.ICON}</span>
      </div>
      <span className="logo-text">{HEADER_CONSTANTS.LOGO.TEXT}</span>
    </Link>
  </div>
))

Logo.displayName = "Logo"

export default Logo
